// Onboarding Templates
// Based on the pig app designs

export const templates = [
    {
        id: 'blank',
        name: 'Blank Canvas',
        description: 'Start from scratch',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Welcome Screen',
                elements: [],
                backgroundColor: '#ffffff',
                width: 375,
                height: 812
            }
        ]
    },
    {
        id: 'pig-app',
        name: 'Pet Connection App',
        description: 'Cute onboarding flow for a pet care app',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Deepen Connection',
                backgroundColor: '#E8E4DF',
                width: 375,
                height: 812,
                elements: [
                    {
                        id: 'el-1',
                        type: 'image',
                        name: 'Pig Illustration',
                        x: 112,
                        y: 250,
                        width: 150,
                        height: 200,
                        imageUrl: 'https://raw.githubusercontent.com/twitter/twemoji/master/assets/72x72/1f437.png',
                        styles: {}
                    },
                    {
                        id: 'el-2',
                        type: 'text',
                        name: 'Title',
                        x: 30,
                        y: 520,
                        width: 315,
                        height: 80,
                        content: 'deepen your connection',
                        styles: {
                            fontSize: '32px',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            fontFamily: 'Poppins'
                        }
                    },
                    {
                        id: 'el-3',
                        type: 'text',
                        name: 'Subtitle',
                        x: 30,
                        y: 600,
                        width: 315,
                        height: 60,
                        content: 'by answering deep questions and taking care of your pet piggy',
                        styles: {
                            fontSize: '14px',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: '1.5',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-4',
                        type: 'dots-indicator',
                        name: 'Progress Dots',
                        x: 137,
                        y: 730,
                        width: 100,
                        height: 20,
                        totalScreens: 3,
                        currentScreen: 0,
                        styles: {}
                    },
                    {
                        id: 'el-5',
                        type: 'button',
                        name: 'Next Button',
                        x: 35,
                        y: 760,
                        width: 305,
                        height: 56,
                        content: 'Next',
                        action: 'next',
                        styles: {
                            backgroundColor: '#5D4037',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            fontFamily: 'Inter'
                        }
                    }
                ]
            },
            {
                id: 'screen-2',
                name: 'Keep Love Alive',
                backgroundColor: '#E8E4DF',
                width: 375,
                height: 812,
                elements: [
                    {
                        id: 'el-6',
                        type: 'image',
                        name: 'Pig with Heart',
                        x: 112,
                        y: 250,
                        width: 150,
                        height: 200,
                        imageUrl: 'https://raw.githubusercontent.com/twitter/twemoji/master/assets/72x72/1f437.png',
                        styles: {}
                    },
                    {
                        id: 'el-7',
                        type: 'text',
                        name: 'Title',
                        x: 30,
                        y: 520,
                        width: 315,
                        height: 80,
                        content: 'keep the love alive',
                        styles: {
                            fontSize: '32px',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            fontFamily: 'Poppins'
                        }
                    },
                    {
                        id: 'el-8',
                        type: 'text',
                        name: 'Subtitle',
                        x: 30,
                        y: 600,
                        width: 315,
                        height: 60,
                        content: 'by sending love letters, playing games, and doing check-ins',
                        styles: {
                            fontSize: '14px',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: '1.5',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-9',
                        type: 'dots-indicator',
                        name: 'Progress Dots',
                        x: 137,
                        y: 730,
                        width: 100,
                        height: 20,
                        totalScreens: 3,
                        currentScreen: 1,
                        styles: {}
                    },
                    {
                        id: 'el-10',
                        type: 'button',
                        name: 'Next Button',
                        x: 35,
                        y: 760,
                        width: 305,
                        height: 56,
                        content: 'Next',
                        action: 'next',
                        styles: {
                            backgroundColor: '#5D4037',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            fontFamily: 'Inter'
                        }
                    }
                ]
            },
            {
                id: 'screen-3',
                name: 'Get Reminders',
                backgroundColor: '#E8E4DF',
                width: 375,
                height: 812,
                elements: [
                    {
                        id: 'el-11',
                        type: 'image',
                        name: 'Pig with Phone',
                        x: 112,
                        y: 250,
                        width: 150,
                        height: 200,
                        imageUrl: 'https://raw.githubusercontent.com/twitter/twemoji/master/assets/72x72/1f437.png',
                        styles: {}
                    },
                    {
                        id: 'el-12',
                        type: 'text',
                        name: 'Title',
                        x: 30,
                        y: 520,
                        width: 315,
                        height: 80,
                        content: 'get a constant reminder',
                        styles: {
                            fontSize: '32px',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            fontFamily: 'Poppins'
                        }
                    },
                    {
                        id: 'el-13',
                        type: 'text',
                        name: 'Subtitle',
                        x: 30,
                        y: 600,
                        width: 315,
                        height: 80,
                        content: 'get new love letters right to your homescreen using our widgets + track days together and your partners mood!',
                        styles: {
                            fontSize: '14px',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: '1.5',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-14',
                        type: 'dots-indicator',
                        name: 'Progress Dots',
                        x: 137,
                        y: 730,
                        width: 100,
                        height: 20,
                        totalScreens: 3,
                        currentScreen: 2,
                        styles: {}
                    },
                    {
                        id: 'el-15',
                        type: 'button',
                        name: 'Get Started Button',
                        x: 35,
                        y: 760,
                        width: 305,
                        height: 56,
                        content: 'Get Started',
                        action: 'next',
                        styles: {
                            backgroundColor: '#5D4037',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            fontFamily: 'Inter'
                        }
                    }
                ]
            }
        ]
    },
    {
        id: 'saas-welcome',
        name: 'SaaS Welcome',
        description: 'Clean onboarding for SaaS products',
        thumbnail: null,
        screens: [
            {
                id: 'screen-1',
                name: 'Welcome',
                backgroundColor: '#ffffff',
                width: 375,
                height: 812,
                elements: [
                    {
                        id: 'el-1',
                        type: 'text',
                        name: 'Welcome Title',
                        x: 30,
                        y: 200,
                        width: 315,
                        height: 100,
                        content: 'Welcome to the Future',
                        styles: {
                            fontSize: '36px',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-2',
                        type: 'text',
                        name: 'Subtitle',
                        x: 30,
                        y: 320,
                        width: 315,
                        height: 60,
                        content: 'Get started in just a few steps',
                        styles: {
                            fontSize: '18px',
                            textAlign: 'center',
                            color: '#666666',
                            fontFamily: 'Inter'
                        }
                    },
                    {
                        id: 'el-3',
                        type: 'button',
                        name: 'Get Started',
                        x: 35,
                        y: 700,
                        width: 305,
                        height: 56,
                        content: 'Get Started',
                        action: 'next',
                        styles: {
                            backgroundColor: '#3b82f6',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            fontFamily: 'Inter'
                        }
                    }
                ]
            }
        ]
    }
];

export default templates;
